var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-cover", on: { click: _vm.onCloseMoreModal } },
    [
      _c(
        "div",
        {
          staticClass: "more-modal",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "more-item attendance",
              on: { click: _vm.onToggleAttendanceModal },
            },
            [_vm._v(_vm._s(_vm.$t("camstudy.moreModal.attendance")))]
          ),
          _c(
            "div",
            {
              staticClass: "more-item stopwatch-setting",
              on: { click: _vm.onToggleStopWatchSettingModal },
            },
            [_vm._v(_vm._s(_vm.$t("camstudy.moreModal.stopwatch")))]
          ),
          _vm.hasEmceeRole()
            ? _c(
                "div",
                {
                  staticClass: "more-item study-setting",
                  on: { click: _vm.onToggleRoomSettingModal },
                },
                [_vm._v(_vm._s(_vm.$t("camstudy.moreModal.studySetting")))]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "more-item white-noise",
              on: { click: _vm.onToggleWhiteNoiseModal },
            },
            [_vm._v(_vm._s(_vm.$t("camstudy.moreModal.whiteNoise")))]
          ),
          _vm.hasEmceeRole()
            ? _c(
                "div",
                {
                  staticClass: "more-item block",
                  on: { click: _vm.onToggleBlockMemberModal },
                },
                [_vm._v(_vm._s(_vm.$t("camstudy.moreModal.blockMember")))]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "more-item chat",
              on: { click: _vm.onToggleChatModal },
            },
            [
              _vm._v(_vm._s(_vm.$t("camstudy.moreModal.chat"))),
              _vm.isExistsUnReadChat
                ? _c("span", { staticClass: "unread-chat" }, [
                    _vm._v(_vm._s(_vm.unReadChatLength)),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "more-item my-setting",
              on: { click: _vm.onToggleMySettingModal },
            },
            [_vm._v(_vm._s(_vm.$t("camstudy.moreModal.setting")))]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }